export const getPaginationRowNumber = (index, page, length) => (
  ((page - 1) * length) + index + 1
);

export const addPaginationRowNumbers = (rows = [], page, length) => (
  rows.map((row, index) => ({
    ...row,
    no: getPaginationRowNumber(index, page, length),
  }))
);
